export default __webpack_public_path__ + "static/media/up_blur.8a610a44.svg";